import { useState, useCallback } from 'react';
import Popup from '../../Popup/Popup';
import ActionLinkButton from '../../../UI/ActionLinkButton/ActionLinkButton';
import FeedbackContent from '../../Popup/content/feedback/Feedback';
import './feedback.scss';

type FeedbackProps = {
    isText?: boolean;
};

const Feedback: React.FC<FeedbackProps> = ({ isText }) => {
    const [isOpen, setOpen] = useState(false);

    const handleOpen = useCallback(() => setOpen(true), []);
    const handleClose = useCallback(() => setOpen(false), []);

    return (
        <div className="footer-feedback">
            {isText ? (
                <button className="footer-feedback_button" type="button" onClick={handleOpen} aria-haspopup="dialog">
                    Написать нам
                </button>
            ) : (
                <ActionLinkButton
                    onClick={handleOpen}
                    iconSrc="/icons/mobile/mail.svg"
                    iconSrcDark="/icons/mobile/mail_w.svg"
                    iconAlt="mail"
                    ariaLabel="Написать нам"
                />
            )}
            <Popup isOpen={isOpen} onClose={handleClose}>
                <FeedbackContent />
            </Popup>
        </div>
    );
};

export default Feedback;
